module.exports = __webpack_public_path__ + "assets/img/dayliner-light.197ae7be.png";